require('./OKRadioGroup.scss');

const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

class OKRadioGroup extends React.Component {
    constructor(props) {
        super(props);
        this.labelElementSection = this.labelElementSection.bind(this);
        this.messageElementSection = this.labelElementSection.bind(this);
    }

    labelElementSection(label, labelId, optionalElementContent) {
        let labelElement;

        if (label) {
            labelElement = (
                <label id={labelId} className="ok-radio-group__label">
                    {label}{optionalElementContent}
                </label>
            );
        }

        return labelElement;
    }

    messageElementSection(errorState, messageId, errorMessage) {
        let messageElement;

        if (errorState) {
            messageElement = (
                <span id={messageId} className="ok-radio-group__message">
                    {errorMessage}
                </span>
            );
        }

        return messageElement;
    }

    render() {
        const {
            children,
            className,
            errorMessage,
            errorState,
            idPrefix,
            isHorizontal,
            label,
            name,
            onChange,
            optionalElement,
            selectedValue
        } = this.props;

        const classes = classNames('ok-radio-group', className, {
            'ok-radio-group--error': errorState
        });

        const clonedChildren = React.Children.map(children, (element, index) => {
            const childProps = {
                id: idPrefix + index,
                inline: isHorizontal,
                isChecked: selectedValue === element.props.value,
                name,
                onChange
            };

            return React.cloneElement(element, childProps);
        });

        let optionalElementContent;
        const labelId = `lbl_${idPrefix}`;
        const messageId = `text_${idPrefix}`;

        if (optionalElement) {
            optionalElementContent = (
                <span className="ok-radio-group__optional-text">
                    {optionalElement}
                </span>
            );
        }

        return (
            <div className={classes} id={idPrefix}>
                {this.labelElementSection(label, labelId, optionalElementContent)}
                {clonedChildren}
                {this.messageElementSection(errorState, messageId, errorMessage)}
            </div>
        );
    }
}

OKRadioGroup.defaultProps = {
    idPrefix: '',
    isHorizontal: false
};

OKRadioGroup.propTypes = {
    children: PropTypes.array.isRequired,
    className: PropTypes.string,
    errorMessage: PropTypes.string,
    errorState: PropTypes.bool,
    idPrefix: PropTypes.string,
    isHorizontal: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    optionalElement: PropTypes.object,
    selectedValue: PropTypes.any
};

module.exports = OKRadioGroup;
